import React from 'react';

export const AirtableSearchResultIcon = () => {
	return (
		<svg width="32" height="32" viewBox="0 0 32 32" fill="none" xmlns="http://www.w3.org/2000/svg">
			<rect
				x="-163.5"
				y="-263.5"
				width="1941"
				height="891"
				rx="4.5"
				stroke="#9747FF"
				strokeDasharray="10 5"
			/>
			<rect width="32" height="32" rx="8" fill="white" />
			<rect x="0.5" y="0.5" width="31" height="31" rx="7.5" stroke="#0B1228" strokeOpacity="0.14" />
			<path
				d="M14.8596 6.89182L6.90601 10.1829C6.46371 10.366 6.46829 10.9942 6.91336 11.1706L14.9003 14.3379C15.6021 14.6162 16.3836 14.6162 17.0853 14.3379L25.0723 11.1706C25.5172 10.9942 25.5219 10.366 25.0795 10.1829L17.126 6.89182C16.4003 6.59156 15.5852 6.59156 14.8596 6.89182Z"
				fill="#FFBF00"
			/>
			<path
				d="M16.7012 16.0675V23.9798C16.7012 24.3561 17.0807 24.6138 17.4305 24.4751L26.3303 21.0206C26.5335 20.9401 26.6667 20.7437 26.6667 20.5252V12.613C26.6667 12.2366 26.2873 11.9789 25.9375 12.1176L17.0376 15.5721C16.8345 15.6527 16.7012 15.849 16.7012 16.0675Z"
				fill="#26B5F8"
			/>
			<path
				d="M14.6231 16.4758L11.9818 17.7511L11.7136 17.8807L6.13804 20.5522C5.7846 20.7227 5.3335 20.4652 5.3335 20.0725V12.6462C5.3335 12.5042 5.40633 12.3816 5.504 12.2892C5.54476 12.2483 5.59094 12.2147 5.63894 12.188C5.77218 12.1081 5.96222 12.0867 6.12381 12.1506L14.5787 15.5006C15.0085 15.6711 15.0422 16.2733 14.6231 16.4758Z"
				fill="#ED3049"
			/>
			<path
				d="M14.623 16.4758L11.9817 17.7511L5.50391 12.2892C5.54466 12.2483 5.59085 12.2147 5.63884 12.188C5.77209 12.1081 5.96213 12.0867 6.12371 12.1506L14.5786 15.5006C15.0084 15.6711 15.0421 16.2733 14.623 16.4758Z"
				fill="black"
				fillOpacity="0.25"
			/>
		</svg>
	);
};
